import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import {
  Row,
  Col,
  ControlLabel,
  Button,
  ButtonToolbar,
} from 'react-bootstrap';


const propTypes = exact({
  doSubmit: PropTypes.func.isRequired,
  cancelSubmit: PropTypes.func.isRequired,
  formValues: PropTypes.object.isRequired,
});


const ConfirmRequest = (props) => {
  const { cancelSubmit, formValues, doSubmit } = props;
  const { employees, ticket_number: ticketNumber, date } = formValues;

  return (
    <React.Fragment>
      {date && (
        <Row>
          <Col xs={12} sm={6} md={4}>
            <ControlLabel>Date:</ControlLabel>
            <span> {date}</span>
          </Col>
        </Row>
      )}
      <Row style={{ paddingBottom: '20px' }}>
        <Col xs={12} sm={6} md={4}>
          <ControlLabel>Ticket Number:</ControlLabel>
          <span> {ticketNumber.number} </span>
          <div>
            <ControlLabel>Employees:</ControlLabel>
            {employees.map((employee) => {
              return (
                <div key={employee.id}>{employee.fullname}</div>
              );
            })}
          </div>
        </Col>
      </Row>
      <Row className="visible-xs">
        <Col xs={12}>
          <Button
            style={{ width: '100%' }}
            bsStyle="warning"
            onClick={() => { return cancelSubmit(formValues); }}
          >
            Back
          </Button>
        </Col>
      </Row>
      <Row className="visible-xs" style={{ paddingTop: '20px' }}>
        <Col xs={12}>
          <Button
            style={{ width: '100%' }}
            bsStyle="primary"
            onClick={() => { return doSubmit(formValues); }}
          >
            Submit
          </Button>
        </Col>
      </Row>
      <Row>
        <Col className="hidden-xs" sm={6} md={4}>
          <ButtonToolbar style={{ paddingTop: '20px' }}>
            <Button
              bsStyle="warning"
              onClick={() => { return cancelSubmit(formValues); }}
            >
              Back
            </Button>
            <Button
              bsStyle="primary"
              onClick={() => { return doSubmit(formValues); }}
            >
              Submit
            </Button>
          </ButtonToolbar>
        </Col>
      </Row>
    </React.Fragment>
  );
};


ConfirmRequest.propTypes = propTypes;

export default ConfirmRequest;
